import { GlobalStyles } from "@mui/material";

/**
 *
 * @description to add the custom styled scroll bar for MUI components
 *
 * @returns  styled scrollbar
 *
 * @author rajkumar rathod
 */
const GlobalStyledScrollBar = () => (
  <GlobalStyles
    styles={{
      "*::-webkit-scrollbar": {
        width: "4px",
        height: "2px",
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        borderRadius: "10px",
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
      },
      "*::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    }}
  />
);

export default GlobalStyledScrollBar;
